/**
 * Manipulates the results of a search queyr before they are rendered.
 *
 * @param {Object[]} results Results to modify
 */
export const modifyResults = results => {
	const translations = window?.QalaElasticCore?.translations || {};
	const wooSettings = window?.QalaElasticCore?.wooSettings || {};
	return results.map( result => modifyResult( result, translations, wooSettings ) ) || []; // Return an empty array if results is null or undefined;
};

/**
 * Modifies a single result object.
 *
 * @param {Object}                             result                         Result object to modify
 * @param {Object}                             translations                   Translations object
 * @param {Object}                             wooSettings                    WooCommerce settings object
 * @param {"default"|"no_amount"|"low_amount"} wooSettings.stockDisplayFormat The format to display stock information in
 * @return {Object} The modified result object
 */
const modifyResult = ( result, translations, wooSettings ) => {
	// Normalize object type to an array
	const objectTypes = Array.isArray( result?.object_type ) ? result.object_type : [ result?.object_type || 'unknown' ];
	const isProduct = objectTypes.includes( 'product' );

	if ( isProduct ) {
		return modifyWooCommerceProduct( result, translations, wooSettings ); // Return the result object if it's not a product
	}

	return result;
};

/**
 * Modifies a WooCommerce product result object based on stock information and display settings.
 *
 * @param {Object} result       The product result object to modify
 * @param {Object} translations Translations object containing necessary translation strings
 * @param {Object} wooSettings  WooCommerce settings object containing stock display format and low stock threshold. Will be empty object if no WooCommerce.
 * @return {Object} The modified product result object
 */
const modifyWooCommerceProduct = ( result, translations, wooSettings ) => {
	const stockFormat = wooSettings?.stockDisplayFormat || 'default';
	const lowStockThreshold = wooSettings?.lowStockThreshold || 5;

	// Manipulate the result object as needed.
	result.stock_status_display = result?.stock_status || '';

	// Check if stock quantity is even set and a number, don't mess with it then (if product doesnt have inventory tracking set).
	// This is from what I see skipped even then (cause the stock_quantity should be 0 if the product
	// doesn't have stock tracking set, bet let's explicitly check for this).
	if ( result?.stock_quantity === undefined || isNaN( result?.stock_quantity ) ) {
		return result;
	}

	// Only really need to modify this when WooCommerce is managing stock.
	if ( result?.is_woo_managing_stock === undefined || result?.is_woo_managing_stock === 'true' ) {
		// Default behavior
		result.stock_status_display = `${ result.stock_quantity || '0' } ${ translations.woocommerce?.inStock }`;

		switch ( stockFormat ) {
			case 'no_amount':
				result.stock_status_display = result?.stock_status || '';
				break;
			case 'low_amount':
				if ( result.stock_quantity > lowStockThreshold ) {
					const hasCustomMessage = wooSettings.overStockThresholdMessage.length > 0;
					result.stock_status_display = hasCustomMessage ? wooSettings.overStockThresholdMessage : ( result?.stock_status || '' );
				}

				if ( result.stock_quantity <= 0 ) {
					result.stock_status_display = result?.stock_status || '';
				}
				break;
		}
	}

	return result;
};
